import Autocomplete, { AutocompleteProps } from "@swvl/autocomplete";

const AutocompleteWrapper = (props: AutocompleteProps) => (
  <Autocomplete minCharacters={4} {...props} />
);

export default AutocompleteWrapper;
